import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import FormModel from "./models/FormModel";

export interface ICountry {
  id: number;
  name: string;
  code: string;
  isdCode: string;
  status: boolean;
}

export const initialFormData: ICountry = {
  id: 0,
  name: "",
  code: "",
  isdCode: "",
  status: false,
};

function Country() {
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [initial, setInitial] = useState<ICountry>(initialFormData);

  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/countries", { headers }).then((res) => {
      if (res.status === 200) setCountries(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/countries/" + id, { headers }).then((res) => {
      if (res.status === 200) setCountries(res.data);
    });
  };

  const handleEdit = (country: ICountry) => {
    setInitial(country);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">Country</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All Countrys
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Name</th>
                      <th style={{ display: "table-cell" }}>Code</th>
                      <th style={{ display: "table-cell" }}>Isc Code</th>
                      <th style={{ display: "table-cell" }}>Is Active</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {countries.length ? (
                      countries.map((religion, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{religion.name}</td>
                            <td>{religion.code}</td>
                            <td>{religion.isdCode}</td>
                            <td>{religion.status ? "Active" : "In Active"}</td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(religion)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(religion.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={3}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{ setCountries, initial, setInitial, modalShow, setModalShow }}
      />
    </div>
  );
}

export default Country;
